import React from 'react'

const GeneralGameInfoModal = () => {
    return (
        <div>
            <h3>Pelin nimi, eg Kotikäyntiseikkailu, Hytoseikkailu tms</h3>


            <p><b>Pelin tarkoitus ja tavoite: </b>
                Tämä on tekstiseikkailupeli, jossa olet lähihoitajaopiskelijana menossa ohjaajasi Teijan kanssa menossa kotikäynnille Pentti Elo nimisen asiakkaan luo. Tavoitteenasi on hoitaa suunnitellut asiat (voit tarkistaa suunnitelman, johon listattu ydinasiat, taustaa Pentistä, lääkekortti etc määrätystä kohtaa). <br /><br />

                <b> Pelissä liikkuminen: </b>Pelissä selvitetään yksi kerrallaan eri tilanteita/ pulmia, joita vastaan tulee. Useimmissa tilanteissa valitse hiirellä sopivimman vaihtoehdon tai kirjoitat jotain sille varattuun tilaan. Jokaisessa tilanteessa on oma ohje miten toimit. <br /><br />
                <b>Näkymän eri osat: </b> Sivun alareunassa näet pelin etenemisen ja tämänhetkisen osaamistasosi, joka perustuu valintoihisi. Alareunassa näet myös edellisen toimintasi ja siihen liittyvän palautteen. Saat sivun alareunan osiosta lisätietoa viemällä hiiren niiden päälle.
            </p>





        </div>
    )
}

export default GeneralGameInfoModal